export const getStoredQueryPathName = ({
  name,
  path,
}: {
  name: string;
  path?: string;
}) => {
  if (path) {
    return `${path}/${name}`;
  }

  return name;
};

export const getEncodedStoredQueryPathName = ({
  name,
  path,
}: {
  name: string;
  path?: string;
}) => {
  const fullPath = path ? `${path}/${name}` : name;
  return encodeURIComponent(fullPath);
};
